import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
// import { globalStyle } from '../../global/style';

// const useStyles = makeStyles(globalStyle);
const useStyles = makeStyles((theme) => ({
  // ...globalStyle,
  layout: {
    justifyContent: 'space-around',
    width: 'auto',
    marginLeft: '64px',
    marginRight: '64px',
    [theme.breakpoints.down('xs')]: {
      marginLeft: theme.spacing(0),
      marginRight: theme.spacing(0),
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
    [theme.breakpoints.up(1160 + theme.spacing(3) * 2)]: {
      // width: 1160,
      marginLeft: '64px',
      marginRight: '64px',
    },
  },
  pageHeader: {
    backgroundColor: theme.palette.primary.main,
    paddingTop: 20,
    paddingBottom: 20,
    color: 'white',
    width: '100%',
    position: 'absolute',
    left: 0,
    top: '60px',
    marginBottom: 20,
    // marginLeft: 'auto',
    // marginRight: 'auto',
    fontSize: '1.8em',
    fontFamily: theme.typography.fontKanit,
    fontWeight: 600,
    // paddingLeft: 64,
    // paddingRight: 64,
    zIndex: -1,
  },
}));

const TitlePage = ({ title }) => {
  const classes = useStyles();
  return (
    <Box>
      <Box mb={2} className={classes.pageHeader}>
        <div className={classes.layout}>
          <Container maxWidth="xl">
            <h4>{title}</h4>
          </Container>
        </div>
      </Box>
      <Box mt={30} />
    </Box>
  );
}

export default TitlePage;